import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

import { type SnackBarOptions } from './snack-bar-options.interface';

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrl: './snack-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackBarComponent {
  data = inject<SnackBarOptions>(MAT_SNACK_BAR_DATA);

  title: string;
  icon: string;

  constructor() {
    const data = this.data;

    this.title = data.title;
    this.icon = data.icon || '';
  }
}
